import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import PieChart from "../charts/PieChart";
import { getComunidad } from "../../controllers/org";
import { useParams } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";

function ComunidadMembresíaGrafica({ membresia, title = 'Membresía' }) {
  const params = useParams();
  const [data, setData] = useState(membresia);
  const { token } = useAuth();

  if (!data) {
    return <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <p>No hay membresía</p>
    </Card.Body>
  </Card>
  }

  let mData = {
    labels: [],
    datasets: [{
      label: '# de miembros',
      borderWidth: 1,
      data: []
    }]
  };
  data.forEach(item => {
    mData.labels.push(`${item.label}`);
    mData.datasets[0].data.push(item.count || item.members_count);
  });

  return <Card>
    <Card.Header>{title}</Card.Header>
    <Card.Body>
      <PieChart data={mData} />
    </Card.Body>
  </Card>;
}

export default ComunidadMembresíaGrafica;
